import _extends from "@babel/runtime/helpers/extends";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _dec4, _class, _descriptor;
import { observable, action, computed } from 'mobx';
import _get from 'lodash/get';
import { mapInitialStateToStoreState } from "../../utils/store.utils/index.js";
/**
 * Errors store
 * responsible for managing the App Errors Across the app
 */
var ErrorsStore = (_dec = action.bound, _dec2 = action.bound, _dec3 = action.bound, _dec4 = action.bound, (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   */
  function ErrorsStore(initialState) {
    if (initialState === void 0) {
      initialState = {};
    }
    _initializerDefineProperty(this, "errors", _descriptor, this);
    this.updateInitialState(initialState);
  }
  var _proto = ErrorsStore.prototype;
  /**
   * push errors
   * @param {Object} error
   */
  _proto.push = function push(error) {
    var _extends2;
    var code = _get(error, 'apiCode');
    if (!code) return;
    this.errors = _extends({}, this.errors, (_extends2 = {}, _extends2[code] = error, _extends2));
  }

  /**
   * remove error
   * @param apiCode
   */;
  _proto.remove = function remove(apiCode) {
    var errors = _extends({}, this.errors);
    delete errors[apiCode];
    this.errors = _extends({}, errors);
  }

  /**
   * reset errors
   */;
  _proto.reset = function reset() {
    this.errors = {};
  }

  /**
   * mapInitialStateToStoreState
   * @param {Object} initialState
   */;
  _proto.updateInitialState = function updateInitialState(initialState) {
    mapInitialStateToStoreState(this, initialState);
  };
  _createClass(ErrorsStore, [{
    key: "errorsList",
    get:
    /**
     * errorsList
     * @returns {Array}
     */
    function get() {
      return Object.values(this.errors);
    }
  }]);
  return ErrorsStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "errors", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, "errorsList", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errorsList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "push", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "push"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "remove", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "remove"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reset", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "reset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateInitialState", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype)), _class));
export { ErrorsStore as default };